import { validates } from '../utils/ValidateFormObject'

const medicamento = {
  tipo: {
    required: true
  },
  document: {
    conditionalRequired(obj) {
      const errorMessage = 'É obrigatório o upload de um arquivo HTML.'
      if (!obj['conteudoHtml']) {
        return {
          required: true,
          errorMessage
        }
      } else {
        return {
          required: false,
          errorMessage
        }
      }
    }
  },
  autores: {
    required: true
  },
  pesoDA: {
    required: true
  },
  idioma: {
    required: true
  },
  palavrasChave: {
    required: true
  },
  codigoProtheus: {
    required: false,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  tituloLivro: {
    required: false
  },
  especialidadesLivro: {
    required: false
  },
  edicaoLivro: {
    required: false
  },
  autoresLivro: {
    required: false
  },
  copyrightLivro: {
    required: false,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  isbn: {
    required: false,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  tituloSecao: {
    required: false
  },
  autoresSecao: {
    required: false
  },
  textoSecao: {
    required: false
  },
  principioAtivo: {
    required: true
  },
  classificacaoTerapeutica: {
    required: true
  },
  livroReferencia: {
    required: false
  }
}

export default medicamento



// WEBPACK FOOTER //
// ./src/contentSchema/medicamento.js